export class SearchHistoryContainer {
    constructor(jobId, jobBoards, jobService, alertsAndNotificationsService) {
        this.jobId = jobId;
        this.jobBoards = jobBoards;
        this.jobService = jobService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
        this.$onInit();
    }
    $onInit() {
        this.searchHistory = [];
        this.busy = false;
        this.searchHistoryExistFlag = true;
        this.currentPromise = null;
        this.disableInfiniteScroll = false;
    }
    getNext() {
        if (this.busy)
            return;
        this.busy = true;
        this.currentPromise = this.jobService.getJobBoardsSearchHistory(this.jobId, this.searchHistoryQueryFilter.pageNum, this.searchHistoryQueryFilter.size, (data) => {
            if (angular.isDefined(data) && data != 'user cancellation') {
                if (data.length > 0) {
                    angular.forEach(data, (search, key) => {
                        search.jobBoards = angular.copy(this._addJobBoardDetails(search.jobBoardId, search.daxtraParameters));
                        delete search.jobBoardId;
                        this.searchHistory.push(search);
                    });
                    console.log('Parsed search history');
                    console.log(this.searchHistory);
                    if (this.searchHistoryQueryFilter.pageNum == 1) {
                        $('.panel-group').css({
                            "height": "500px",
                            "overflow-y": "scroll"
                        });
                    }
                    if (data.length < this.searchHistoryQueryFilter.size) {
                        this.disableInfiniteScroll = true;
                    }
                    else {
                        this.searchHistoryQueryFilter.pageNum++;
                    }
                }
                else {
                    this.disableInfiniteScroll = true;
                }
                if (this.searchHistory.length > 0) {
                    this.searchHistoryExistFlag = true;
                }
                else {
                    this.searchHistoryExistFlag = false;
                }
            }
            this.busy = false;
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    _addJobBoardDetails(jobBoardIds, daxtraParameters) {
        let jobBoards = [];
        angular.forEach(jobBoardIds, (jobBoardId, key) => {
            let jobBoard = this.jobBoards.find((jobBoard) => {
                return jobBoard.id === jobBoardId;
            });
            //Parse daxtra params
            // jobBoard.allDaxtraParameters = angular.copy(_addDaxtraParametersToJobBoard(daxtraParameters, jobBoard.daxtraCode.toLowerCase()));
            // jobBoard.daxtraParameters = jobBoard.allDaxtraParameters.filter(function (param) {
            //     return param.value !== "";
            // });
            jobBoards.push(jobBoard);
        });
        return jobBoards;
    }
}
//# sourceMappingURL=job-boards-search-history-infinite-scroll.js.map